import 'bootstrap/dist/css/bootstrap.min.css';
import { Linkedin, Mail } from 'lucide-react'; 

import anushree from "../assets/team/anushree.jpeg";
import arvind from "../assets/team/arvind.JPG";
import archana from "../assets/team/archana.JPG";
import deepak from "../assets/team/deepak.JPG";
import komal from "../assets/team/komal.JPG";
import neeraj from "../assets/team/neeraj.JPG";
import rahul from "../assets/team/rahul.JPG";
import reena from "../assets/team/reena.JPG";
import rohan from "../assets/team/rohan.JPG";
import shruti from "../assets/team/shruti.JPG";
import saumya from "../assets/team/saumya.JPG";
import ayushi_mittal from "../assets/team/ayushi.jpg";
import raghav from "../assets/team/raghav.JPG";

const teamMembers = [
  {
    id: 1,
    name: "Mr. Arvind Gupta",
    role: "Director",
    image: arvind, // Replace with real image variable
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 2,
    name: "Mr. Neeraj Gupta",
    role: "Director",
    image: neeraj,
    bio: "",
    social: {
    //   linkedin: "#",
      email: "info@hs-india.com"
    }
  },
  {
    id: 3,
    name: "Mr. Deepak Gupta",
    role: "Director",
    image: deepak,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 4,
    name: "Mrs. Komal Gupta",
    role: "Manager",
    image: komal,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 5,
    name: "Mrs. Reena Gupta",
    role: "Manager",
    image: reena,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 6,
    name: "Mr. Raghav Mittal",
    role: "Manager",
    image: raghav,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 7,
    name: "Ms. Anushree",
    role: "Designer",
    image: anushree,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 8,
    name: "Mrs. Ayushi Mittal",
    role: "Senior HR Manager",
    image: ayushi_mittal,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 9,
    name: "Mrs. Archana Gupta",
    role: "Director",
    image: archana,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 10,
    name: "Mr. Rahul Gupta",
    role: "Manager",
    image: rahul,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 11,
    name: "Mrs. Shruti Gupta",
    role: "Designer",
    image: shruti,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 12,
    name: "Mr. Rohan Gupta",
    role: "Manager",
    image: rohan,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  },
  {
    id: 13,
    name: "Mrs. Saumya Jain",
    role: "Manager",
    image: saumya,
    bio: "",
    social: {
      email: "info@hs-india.com"
    }
  }
];

const CompanyProfile = () => {
  return (
    <section className="py-5 bg-light">
      <div className="container">
        
        {/* Section Header */}
        <div className="row justify-content-center mb-5">
          <div className="col-12">
            <h1 className="custom-heading display-5 fw-bold mb-3">Meet the Minds Behind HS India</h1>
            <hr className="custom-divider" />
          </div>
        </div>

        {/* Team Grid */}
        <div className="row g-4 justify-content-center">
          {teamMembers.map((member) => (
            <div key={member.id} className="col-md-6 col-lg-3">
              <div className="card h-100 border-0 shadow-sm hover-card" style={{ transition: 'transform 0.3s ease', borderRadius: '15px', overflow: 'hidden' }}>
                
                {/* Image Area */}
                <div className="position-relative">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="card-img-top"
                    style={{ height: '350px', objectFit: 'cover', objectPosition: 'top' }}
                  />
                  <div className="position-absolute bottom-0 start-0 w-100 p-3" 
                       style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)' }}>
                  </div>
                </div>

                {/* Content Area */}
                <div className="card-body text-center p-3">
                  <h4 className="fw-bold mb-1">{member.name}</h4>
                  <p className="fw-medium mb-3" style={{ color: '#d70077' }}>{member.role}</p>
                  <p className="card-text text-muted small mb-2">
                    {member.bio}
                  </p>
                  
                  {/* Social Icons */}
                  <div className="d-flex justify-content-center gap-3">
                    {member.social.linkedin && (
                      <a href={member.social.linkedin} className="text-dark hover-primary" aria-label="LinkedIn">
                        <Linkedin size={20} />
                      </a>
                    )}
                    {member.social.email && (
                      <a href={`mailto:${member.social.email}`} className="text-dark hover-primary" aria-label="Email">
                        <Mail size={20} />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Inline Styles for simplicity (or move to CSS file) */}
      <style jsx>{`
        .hover-card:hover {
          transform: translateY(-10px) !important;
          box-shadow: 0 1rem 3rem rgba(0,0,0,.175) !important;
        }
        .hover-primary:hover {
          color: #d70077 !important;
          transition: color 0.2s ease;
        }
      `}</style>
    </section>
  );
};

export default CompanyProfile;